<template>
	<div class="lab-notes">
      <div v-if="value" class="printable-notes" data-print="enabled">
        <p class="printable-notes-title"><b>Lab Notes:</b></p>
        <div class="printable-notes-description" v-html="printableCustomDesc" />
      </div>
		<div class="tour-target">
      <input-area
        data-print="disabled"
        id="lab-notes-area"
        name="lab-notes-area"
        tag="textarea"
        label="Add notes"
        :value="value"
        @input="handleInputChange"
        data-cy="lab-notes-area"
        style="resize: none"
        maxlength=5000
      />
		</div>
	</div>
</template>

<script>
export default {
	name: 'LabNotes',
	props: {
    	value: {
 			type: String,
 		},
		tourActive: {
			type: Boolean,
			default: false
		},
	},
  computed: {
    printableCustomDesc() {
      return this.value
        .split("\n")
        .filter(paragraph => paragraph)
        .map(paragraph => `<p style="font-family: Futura W01 Book; color: #000; opacity: 0.72; padding: 0; margin: 0 ; word-break: break-all;">${paragraph}</p>`)
        .toString()
        .replace(/,/g, '');
    },
  },
  methods: {
    handleInputChange(e) {
      this.$emit("input", e)
    }
  }
};
</script>

<style lang="scss" scoped>
	[data-print='enabled'] {
		visibility: hidden;
		height: 0px;
	}
	.lab-notes {
		margin-top: 10px;
		padding: 0 16px 24px;
		label {
			color: $color-text-grey;
			margin-bottom: 0;
		}
		.printable-notes {
			&-title {
				margin-bottom: 5px !important;
			}
			&-description {
				color: $color-text-grey !important;
				font-size: 14px !important;
			}
			p {
				word-break: break-all;
			}
		}
		.md-field {
			margin-bottom: 0;
		}
	}
</style>
